import { useState, useRef, useEffect } from 'react';
import { Fab, IconButton, Menu, MenuItem, Paper, Typography, ListItemIcon, ListItemText } from '@mui/material';
import { Chat, Close, WhatsApp, Telegram } from '@mui/icons-material';
import {Helper} from "../../tools/Helper";
import {api_Routes} from "../../api_Routes";

const FloatingChatButton = () => {
    const containerRef = useRef(null);
    const [mainMenuOpen, setMainMenuOpen] = useState(false);
    const [whatsappAnchor, setWhatsappAnchor] = useState(null);
    const [telegramAnchor, setTelegramAnchor] = useState(null);
    const [contacts, setContacts] = useState({ whatsapp: [], telegram: [] });

    useEffect(() => {
        const fetchContacts = async () => {
            try {
                const {response} = await Helper.Get({
                    url: `${api_Routes.Header.getMarketers}`,
                    hasToken: true,
                });
                console.log(response.data)
                const grouped = {
                    whatsapp: response.data.filter(c => c.platform === 'whatsapp'),
                    telegram: response.data.filter(c => c.platform === 'telegram')
                };
                setContacts(grouped);
            } catch (error) {
                console.error('Error fetching contacts:', error);
            }
        };

        fetchContacts();
    }, []);
// console.log(contacts)
    // const contacts = {
    //     whatsapp: [
    //         { name: "Gemma", number: "1234567890", message: "Hi" },
    //         { name: "Nour", number: "0987654321", message: "Hi" }
    //     ],
    //     telegram: [
    //         { name: "Ruba", username: "ruba_support", message: "Hi" }
    //     ]
    // };

    useEffect(() => {
        console.log(mainMenuOpen)
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                closeAllMenus();
            }
        };

        if (mainMenuOpen || whatsappAnchor || telegramAnchor) {
            document.addEventListener('click', handleClickOutside);
        }
        return () => document.removeEventListener('click', handleClickOutside);
    }, [ ]);

    const closeAllMenus = () => {
        setMainMenuOpen(false);
        setWhatsappAnchor(null);
        setTelegramAnchor(null);
    };

    const handleMainMenuToggle = () => {
        setMainMenuOpen(prev => !prev);
    };

    const handlePlatformClick = (platform, event) => {
        event.stopPropagation();
        if (platform === 'whatsapp') {
            setWhatsappAnchor(event.currentTarget);
            setTelegramAnchor(null);
        } else {
            setTelegramAnchor(event.currentTarget);
            setWhatsappAnchor(null)
        }
    };

    return (
        <div ref={containerRef} style={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 9999
        }}>
            {/* Main FAB Button */}
            <Fab
                color="primary"
                onClick={handleMainMenuToggle}
                sx={{
                    transition: 'transform 0.3s',
                    transform: mainMenuOpen ? 'rotate(135deg)' : 'rotate(0deg)'
                }}
            >
                {mainMenuOpen ? <Close /> : <Chat />}
            </Fab>

            {/* Main Menu with Platform Icons */}
            {mainMenuOpen && (
                <Paper
                    sx={{
                        position: 'absolute',
                        bottom: 60,
                        right: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1,
                        p: 1,
                        boxShadow: 3,
                        borderRadius: 4
                    }}
                >
                    <IconButton
                        onClick={(e) => handlePlatformClick('whatsapp', e)}
                        sx={{ color: '#25D366' }}
                    >
                        <WhatsApp fontSize="large" />
                    </IconButton>

                    <IconButton
                        onClick={(e) => handlePlatformClick('telegram', e)}
                        sx={{ color: '#0088cc' }}
                    >
                        <Telegram fontSize="large" />
                    </IconButton>
                </Paper>
            )}

            {/* WhatsApp Submenu */}
            <Menu
                anchorEl={whatsappAnchor}
                open={Boolean(whatsappAnchor)}
                onClose={() => setWhatsappAnchor(null)}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Typography variant="subtitle1" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
                    WhatsApp Contacts
                </Typography>
                {contacts.whatsapp.map((contact, index) => (
                    <MenuItem
                        key={index}
                        component="a"
                        href={`https://wa.me/${contact.identifier}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={closeAllMenus}
                    >
                        <ListItemText
                            primary={contact.name}
                            secondary={contact.message}
                            primaryTypographyProps={{ fontWeight: 'medium' }}
                            secondaryTypographyProps={{ variant: 'body2' }}
                        />
                    </MenuItem>
                ))}
            </Menu>

            {/* Telegram Submenu */}
            <Menu
                anchorEl={telegramAnchor}
                open={Boolean(telegramAnchor)}
                onClose={() => setTelegramAnchor(null)}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Typography variant="subtitle1" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
                    Telegram Contacts
                </Typography>
                {contacts.telegram.map((contact, index) => (
                    <MenuItem
                        key={index}
                        component="a"
                        href={`https://t.me/${contact.identifier}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={closeAllMenus}
                    >
                        <ListItemText
                            primary={contact.name}
                            secondary={contact.message}
                            primaryTypographyProps={{ fontWeight: 'medium' }}
                            secondaryTypographyProps={{ variant: 'body2' }}
                        />
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default FloatingChatButton;